<template>
    <div class="new-page-main">
        <div class="search-bar">
            <div class="left-bar">
                <Button :type="filters.timeSolt===1?'primary':'default'" v-on:click="changeTimeSolt(1)">近一周</Button>
                <Button :type="filters.timeSolt===2?'primary':'default'" v-on:click="changeTimeSolt(2)">近一月</Button>
                <Button :type="filters.timeSolt===3?'primary':'default'" v-on:click="changeTimeSolt(3)">近一年</Button>
            </div>
            <div class="right-bar">
                <div
                    :class="(schoolCode!=0&&dataDetailsIndex==1)||(schoolCode!=0&&dataDetailsIndex==2) ? 'right-mian':'right-mian_active'">
                    <input :placeholder="placeholder" class="input-cla" v-model="filters.keyWord"
                           v-on:keyup.enter="handleSearch"/>
                    <div class="search-btn" v-on:click="handleSearch">
                        <div class="search-icon">
                            <img src="../../../../assets/images/databoard/detailPage/search.png" width="100%"
                                 height="100%"/>
                        </div>
                    </div>
                </div>
                <!--资源数据导出按钮-->
                <div v-if="schoolCode!=0">
                    <div class="data-right-bar" v-if="dataDetailsIndex==1||dataDetailsIndex==2">
                        <Button type="primary" v-on:click="exportInfoToExcel">导出Excel</Button>
                    </div>
                </div>
            </div>
        </div>
        <!--数据展示切换-->
        <div class="data-tab-area">
            <Tabs type="card" @on-click="changeDataDetailsIndex" :value="tabsName">
                <TabPane label="资源详情" name="resource"></TabPane>
                <TabPane label="微课详情" name="microClass"></TabPane>
                <TabPane label="作业详情" name="homework"></TabPane>
                <TabPane label="课堂评价" name="classJudge"></TabPane>
                <TabPane label="云端报告" name="cloudReport"></TabPane>
            </Tabs>
        </div>
        <!--资源页面表格-->
        <div v-if="dataDetailsIndex==1">
            <!--数据统计图-->
            <div class="data-statistics-img" ref="dataStatistics">
                <ul>
                    <li class="circle-data">
                        <div class="data">{{resourceMap.resourceViewCount}}</div>
                        <div class="label">分享资源数</div>
                    </li>
                    <li class="circle-data" style="margin-right:0;">
                        <div class="data">{{resourceMap.resourceViewNum}}</div>
                        <div class="label">资源查看量</div>
                    </li>
                </ul>
            </div>
            <div class="new-table-main-wrap">
                <div class="table-main">
                    <div class="table-content">
                        <div class="header">
                            <Col :span="2">
                            <span>序号</span>
                            </Col>
                            <Col :span="4">
                            <span>学校名称</span>
                            </Col>
                            <Col :span="4">
                            <span>资源名称</span>
                            </Col>
                            <Col :span="4">
                            <span>文件格式</span>
                            </Col>
                            <Col :span="2">
                            <span>上传人</span>
                            </Col>
                            <Col :span="4">
                            <span>上传时间</span>
                            </Col>
                            <Col :span="4">
                            <span>资源大小</span>
                            </Col>
                        </div>
                        <div class="row-wrap">
                            <template v-for="(item,index) in resourceList" v-if="resourceList.length>0">
                                <Row :gutter="12" :class="index % 2 === 0 ? 'row-single':'row-double'">
                                    <Col :span="2" class="col-content">
                                    <span>{{item.rowNum}}</span>
                                    </Col>
                                    <Col :span="4" class="col-content">
                                    <span>{{item.schoolName ==='' ? '暂无':item.schoolName}}</span>
                                    </Col>
                                    <Col :span="4" class="col-content">
                                    <template v-if="item.title===''">
                                        <span :title="item.title">暂无</span>
                                    </template>
                                    <template v-else>
                                        <a :title="item.title" href="javascript:void(0);"
                                           v-on:click="openPreview(item.userId,item.resultUrl,item.count,item.fileType,index,'resource')"
                                           style="color: #2d8cf0;">{{item.title}}</a>
                                    </template>
                                    </Col>
                                    <Col :span="4" class="col-content">
                                    <span>{{item.fileExt}}</span>
                                    </Col>
                                    <Col :span="2" class="col-content">
                                    <span>{{item.userRealName ==='' ? '暂无':item.userRealName}}</span>
                                    </Col>
                                    <Col :span="4" class="col-content">
                                    <span>{{item.createTime ==='' ? '暂无':item.createTime}}</span>
                                    </Col>
                                    <Col :span="4" class="col-content">
                                    <span>{{$utils.bytesToSize(item.fileSize)}}</span>
                                    </Col>
                                </Row>
                            </template>
                            <template v-if="resourceList.length===0">
                                <Row :gutter="12" class="row-single">
                                    <Col :span="24">
                                    <span>暂无数据</span>
                                    </Col>
                                </Row>
                            </template>
                        </div>
                    </div>
                </div>
                <!--<div class="img-ml-box" data-type="question">-->
                    <!--&lt;!&ndash;遮罩层背景&ndash;&gt;-->
                    <!--<div class="img-ml-bg"></div>-->
                    <!--<audio id="audio-player" class="audio" controls="true" autoplay="true" style="display: none"></audio>-->
                    <!--<div id="audio-player-container" class="audio-player-container">-->
                        <!--<div class="play-btn play"></div>-->
                        <!--<div class="audio-progress">-->
                            <!--<div class="audio-progress-bar" style="width: 0;"></div>-->
                        <!--</div>-->
                    <!--</div>-->
                    <!--&lt;!&ndash;关闭按钮&ndash;&gt;-->
                    <!--<a href="javascript:void(0)" class="img-ml-close"></a>-->
                <!--</div>-->
                <div class="bottom-page">
                    <div class="laypage_main">
                        <Page :total="pageParams.total" @on-change="handleCurrentChange" :current="pageParams.page"
                              v-if="pageParams.total && pageParams.pageCount>1"></Page>
                    </div>
                </div>
            </div>
        </div>
        <!--微课页面表格-->
        <div v-if="dataDetailsIndex==5">
            <!--数据统计图-->
            <div class="data-statistics-img" ref="dataStatistics">
                <ul>
                    <li class="circle-data">
                        <div class="data">{{microClassNums}}</div>
                        <div class="label">微课总数</div>
                    </li>
                </ul>
            </div>
            <div class="new-table-main-wrap">
                <div class="table-main">
                    <div class="table-content">
                        <div class="header">
                            <Col :span="4">
                            <span>序号</span>
                            </Col>
                            <Col :span="4">
                            <span>学校名称</span>
                            </Col>
                            <Col :span="4">
                            <span>微课名称</span>
                            </Col>
                            <Col :span="4">
                            <span>上传人</span>
                            </Col>
                            <Col :span="4">
                            <span>创建时间</span>
                            </Col>
                            <Col :span="4">
                            <span>微课大小</span>
                            </Col>
                        </div>
                        <div class="row-wrap">
                            <template v-for="(item,index) in microList" v-if="microList.length>0">
                                <Row :gutter="12" :class="index % 2 === 0 ? 'row-single':'row-double'">
                                    <Col :span="4" class="col-content">
                                    <span>{{item.rowNum}}</span>
                                    </Col>
                                    <Col :span="4" class="col-content">
                                    <span>{{item.school_name ==='' ? '暂无':item.school_name}}</span>
                                    </Col>
                                    <Col :span="4" class="col-content">
                                    <template v-if="item.title===''">
                                        <span :title="item.title">暂无</span>
                                    </template>
                                    <template v-else>
                                        <a :title="item.title" href="javascript:void(0);"
                                           v-on:click="openPreview(item.userId,item.file1,0,2,index,'micro')"
                                           style="color: #2d8cf0;">{{item.title}}</a>
                                    </template>
                                    </Col>
                                    <Col :span="4" class="col-content">
                                    <span>{{item.realname}}</span>
                                    </Col>
                                    <Col :span="4" class="col-content">
                                    <span>{{item.created_at ==='' ? '暂无':item.created_at}}</span>
                                    </Col>
                                    <Col :span="4" class="col-content">
                                    <span>{{$utils.bytesToSize(item.file_size)}}</span>
                                    </Col>
                                </Row>
                            </template>
                            <template v-if="microList.length===0">
                                <Row :gutter="12" class="row-single">
                                    <Col :span="24">
                                    <span>暂无数据</span>
                                    </Col>
                                </Row>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="bottom-page">
                    <div class="laypage_main">
                        <Page :total="pageParams.total" @on-change="handleCurrentChange" :current="pageParams.page"
                              v-if="pageParams.total && pageParams.pageCount>1"></Page>
                    </div>
                </div>
            </div>
        </div>
        <!--作业页面表格-->
        <div v-if="dataDetailsIndex==2">
            <!--数据统计图-->
            <div class="data-statistics-img" ref="dataStatistics">
                <ul style="width:505px;">
                    <li class="circle-data">
                        <div class="data">{{homeworkMap.homeWorkNum}}</div>
                        <div class="label">布置作业数</div>
                    </li>
                    <li class="circle-data">
                        <div class="data">{{homeworkMap.submitJobsNum}}</div>
                        <div class="label">提交作业数</div>
                    </li>
                    <li class="circle-data" style="margin-right:0;">
                        <div class="data">{{homeworkMap.correctionWorkNum}}</div>
                        <div class="label">批改作业数</div>
                    </li>
                </ul>
            </div>
            <div class="new-table-main-wrap">
                <div class="table-main">
                    <div class="table-content">
                        <div class="header">
                            <Col :span="2">
                            <span>序号</span>
                            </Col>
                            <Col :span="4">
                            <span>学校名称</span>
                            </Col>
                            <Col :span="4">
                            <span>作业名称</span>
                            </Col>
                            <Col :span="4">
                            <span>布置人</span>
                            </Col>
                            <Col :span="5">
                            <span>布置时间</span>
                            </Col>
                            <Col :span="5">
                            <span>学科</span>
                            </Col>
                        </div>
                        <div class="row-wrap">
                            <template v-for="(item,index) in homeworkList" v-if="homeworkList.length>0">
                                <Row :gutter="12" :class="index % 2 === 0 ? 'row-single':'row-double'">
                                    <Col :span="2" class="col-content">
                                    <span>{{item.rowNum}}</span>
                                    </Col>
                                    <Col :span="4" class="col-content">
                                    <span>{{item.schoolName==='' ? '暂无':item.schoolName}}</span>
                                    </Col>
                                    <Col :span="4" class="col-content">
                                    <!--<span>{{item.workTitle==='' ? '暂无':item.workTitle}}</span>-->
                                    <template v-if="item.workTitle===''">
                                        <span>暂无</span>
                                    </template>
                                    <template v-else>
                                        <a :title="item.workTitle" href="javascript:void(0);"
                                           v-on:click=" findUserSubjectByUserId(item.teaId,item.workId,item.workTitle,item.hwType,item.hwTypeCode)"
                                           style="color: #2d8cf0;">{{item.workTitle}}</a>
                                    </template>
                                    </Col>
                                    <Col :span="4" class="col-content">
                                    <span>{{item.displayName ==='' ? '暂无':item.displayName}}</span>
                                    </Col>
                                    <Col :span="5" class="col-content">
                                    <span>{{item.create_time ==='' ? '暂无':item.create_time}}</span>
                                    </Col>
                                    <Col :span="5" class="col-content">
                                    <span>{{item.bankName ==='' ? '暂无':item.bankName}}</span>
                                    </Col>
                                </Row>
                            </template>
                            <template v-if="homeworkList.length===0">
                                <Row :gutter="12" class="row-single">
                                    <Col :span="24">
                                    <span>暂无数据</span>
                                    </Col>
                                </Row>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="bottom-page">
                    <div class="laypage_main">
                        <Page :total="pageParams.total" @on-change="handleCurrentChange" :current="pageParams.page"
                              v-if="pageParams.total && pageParams.pageCount>1"></Page>
                    </div>
                </div>
            </div>
        </div>
        <!--课堂评价页面表格-->
        <div v-if="dataDetailsIndex==3">
            <div class="details-table-main-wrap" ref="classTableDetails">
                <div class="table-main">
                    <div class="table-content">
                        <div class="header">
                            <Col :span="2">
                            <span>序号</span>
                            </Col>
                            <Col :span="4">
                            <span>学校名称</span>
                            </Col>
                            <Col :span="4">
                            <span>班级名称</span>
                            </Col>
                            <Col :span="3">
                            <span>教师姓名</span>
                            </Col>
                            <Col :span="3">
                            <span>学生姓名</span>
                            </Col>
                            <Col :span="4">
                            <span>互动内容</span>
                            </Col>
                            <Col :span="4">
                            <span>互动时间</span>
                            </Col>
                        </div>
                        <div class="row-wrap">
                            <template v-for="(item,index) in classInterList" v-if="classInterList.length>0">
                                <Row :gutter="12" :class="index % 2 === 0 ? 'row-single':'row-double'">
                                    <Col :span="2">
                                    <span>{{item.rowNum}}</span>
                                    </Col>
                                    <Col :span="4" class="col-content">
                                    <span>{{$utils.isEmpty(item.schoolName) ===true ? '暂无':item.schoolName}}</span>
                                    </Col>
                                    <Col :span="4" class="col-content">
                                    <span>{{$utils.isEmpty(item.className) ===true ? '暂无':item.className}}</span>
                                    </Col>
                                    <Col :span="3" class="col-content">
                                    <span>{{$utils.isEmpty(item.teaName) ===true ? '暂无':item.teaName}}</span>
                                    </Col>
                                    <Col :span="3" class="col-content">
                                    <span>{{$utils.isEmpty(item.stuName) ===true ? '暂无':item.stuName}}</span>
                                    </Col>
                                    <Col :span="4" class="col-content">
                                    <template v-if="$utils.isEmpty(item.questionName)">
                                        <span>暂无</span>
                                    </template>
                                    <template v-else>
                                        <a :title="item.questionName" href="javascript:void(0);"
                                           v-on:click="lookInterInfo(item)"
                                           style="color: #2d8cf0;">{{item.questionName}}</a>
                                    </template>
                                    </Col>
                                    <Col :span="4" class="col-content">
                                    <span>{{$utils.isEmpty(item.createDate) ===true ? '暂无':item.createDate}}</span>
                                    </Col>
                                </Row>
                            </template>
                            <template v-if="classInterList.length===0">
                                <Row :gutter="12" class="row-single">
                                    <Col :span="24">
                                    <span>暂无数据</span>
                                    </Col>
                                </Row>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="bottom-page">
                    <div class="laypage_main">
                        <Page :total="pageParams.total" @on-change="handleCurrentChange" :current="pageParams.page"
                              v-if="pageParams.total && pageParams.pageCount>1"></Page>
                    </div>
                </div>
            </div>
        </div>
        <!--云端报告页面表格-->
        <div v-if="dataDetailsIndex==4">
            <div class="details-table-main-wrap" ref="cloudTableDetails">
                <div class="table-main">
                    <div class="table-content">
                        <div class="header">
                            <Col :span="2">
                            <span>序号</span>
                            </Col>
                            <Col :span="6">
                            <span>学校名称</span>
                            </Col>
                            <Col :span="6">
                            <span>报告名称</span>
                            </Col>
                            <Col :span="5">
                            <span>教师姓名</span>
                            </Col>
                            <Col :span="5">
                            <span>创建时间</span>
                            </Col>
                        </div>
                        <div class="row-wrap">
                            <template v-for="(item,index) in classInterList" v-if="classInterList.length>0">
                                <Row :gutter="12" :class="index % 2 === 0 ? 'row-single':'row-double'">
                                    <Col :span="2">
                                    <span>{{item.rowNum}}</span>
                                    </Col>
                                    <Col :span="6" class="col-content">
                                    <span>{{item.schoolName ==='' ? '暂无':item.schoolName}}</span>
                                    </Col>
                                    <Col :span="6" class="col-content">
                                    <template v-if="item.workName===''">
                                        <span>暂无</span>
                                    </template>
                                    <template v-else>
                                        <a :title="item.workName" href="javascript:void(0);"
                                           v-on:click="lookReport(item.workId,item.qtype)" style="color: #2d8cf0;">{{item.workName}}</a>
                                    </template>
                                    </Col>
                                    <Col :span="5" class="col-content">
                                    <span>{{item.realname ==='' ? '暂无':item.realname}}</span>
                                    </Col>
                                    <Col :span="5" class="col-content">
                                    <span>{{item.createDate ==='' ? '暂无':item.createDate}}</span>
                                    </Col>
                                </Row>
                            </template>
                            <template v-if="classInterList.length===0">
                                <Row :gutter="12" class="row-single">
                                    <Col :span="24">
                                    <span>暂无数据</span>
                                    </Col>
                                </Row>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="bottom-page">
                    <div class="laypage_main">
                        <Page :total="pageParams.total" @on-change="handleCurrentChange" :current="pageParams.page"
                              v-if="pageParams.total && pageParams.pageCount>1"></Page>
                    </div>
                </div>
            </div>
        </div>
        <!--分页-->
        <div v-show="isShowModal">
            <div class="mask-box"></div>
            <div class="panel-box">
                <div class="close-btn">
                    <img class="logo-img" src="../../../../assets/images/databoard/close_btn.png" width="100%"
                         height="100%"
                         v-on:click="closeWin"/>
                </div>
                <div class="panel-main">
                    <div class="icon-box-wrap">
                        <img class="icon-box" :src="currentInter.evaluateTypeIcon" width="100%" height="100%">
                        <p class="icon-txt">{{currentInter.questionName}}</p>
                    </div>
                    <div class="info-box">
                        <p><span class="txt-item">{{currentInter.schoolName}}</span>
                            <span class="txt-item">{{currentInter.teaName}}老师</span> 对 <span class="txt-item">{{currentInter.stuName}}</span>
                            学生 </p>
                        <p>进行了 “ {{currentInter.questionName}} ” 的课堂互动</p>
                    </div>
                </div>
            </div>
        </div>
        <!--预览轮播-->
        <!--<preview-slider-->
            <!--ref="previewSlider"-->
            <!--:previewMode="previewMode"-->
            <!--:previewVideoMode="previewVideoMode"-->
            <!--:videoSrc="videoSrc"-->
            <!--@closePreview="closePreview"-->
        <!--&gt;</preview-slider>-->
        <!-- 预览轮播 -->
        <dt-preview-slider
                ref="previewSlider"
                :previewMode="previewMode"
                :previewVideoMode="previewVideoMode"
                :videoSrc="videoSrc"
                @closePreview="closePreview"
        ></dt-preview-slider>
    </div>
</template>

<script>
    import {
        findUserInfo,
        findResourceList,
        findHomeWorkList,
        findInterEvaLList,
        findReportList,
        resourceViewMap,
        homeWorkNumMap,
        findCoursewaresInfoList
    } from "../../../../service/api.js";
    import {mapGetters} from 'vuex'

    // const previewSlider = () => import("../baseData/previewSlider");
    export default {
        name: "new-data-list",
        // components: {
        //     previewSlider
        // },
        computed: {
            ...mapGetters([
                'homeWorkReportPath'
            ]),
        },
        data() {
            return {
                classInterList: [],//课堂评价集合
                reportList: [],//云端报告集合
                resourceList: [],//资源详情集合
                homeworkList: [],//作业详情集合
                filters: {
                    schoolId: this.$route.params.schoolId == 0 ? '' : this.$route.params.schoolId,
                    timeSolt: 0,
                    keyWord: '',
                    startDate: '',
                    endDate: ''
                },
                pageParams: {
                    page: 1,
                    limit: 10,
                    total: 0,
                    pageCount: 0
                },
                previewMode: false,
                previewVideoMode: false,
                videoSrc: "",
                tabsName: this.$route.params.tabsName,
                dataDetailsIndex: 1,
                isShowModal: false,
                currentInter: {},
                resourceMap: {},//资源饼图统计
                homeworkMap: {},//作业饼图统计
                dataDetailStyle: {
                    height: '0px'
                },
                placeholder:'',
                hwUserSubjectId: null,
                microClassNums:0,
                schoolCode: this.$route.params.schoolCode
            }
        },
        created() {
            let currentPathArr;
            currentPathArr = [
                {
                    title: "首页",
                    path: "databoard",
                    name: "databoard",
                    params: {
                        schoolCode: this.$route.params.schoolCode,
                    }
                },
                {
                    title: this.$route.params.schoolName,
                    path: "",
                    name: "schoolName"
                },
                {
                    title: "全部资源",
                    path: "",
                    name: "resourceList"
                }
            ];
            this.$store.commit("setCurrentPath", currentPathArr);
        },
        methods: {
            /**
             * 导出产品信息
             */
            exportInfoToExcel() {
                //导出资源详情数据
                if (this.dataDetailsIndex == 1) {
                    let url =
                        process.env.VUE_APP_APIURL +
                        "/website/bord/exportResourceInfoToExcel?schoolId=" +
                        this.filters.schoolId +
                        "&startDate=" +
                        this.filters.startDate +
                        "&endDate=" +
                        this.filters.endDate;
                    let iframe = document.createElement("iframe");
                    iframe.style.display = "none";
                    iframe.src = url;
                    iframe.onload = function () {
                        document.body.removeChild(iframe);
                    };
                    document.body.appendChild(iframe);
                } else if (this.dataDetailsIndex == 2) {
                    //导出作业详情数据
                    let url =
                        process.env.VUE_APP_APIURL +
                        "/website/bord/exportHwStuHomeWorkToExcel?schoolId=" +
                        this.filters.schoolId +
                        "&startDate=" +
                        this.filters.startDate +
                        "&endDate=" +
                        this.filters.endDate;
                    let iframe = document.createElement("iframe");
                    iframe.style.display = "none";
                    iframe.src = url;
                    iframe.onload = function () {
                        document.body.removeChild(iframe);
                    };
                    document.body.appendChild(iframe);
                }
            },
            /**
             * 点击切换详细数据
             */
            changeDataDetailsIndex(name) {
                this.pageParams.page = 1;
                this.pageParams.total = 0;
                let currentPathArr;
                //点击切换至资源详情
                if (name === "resource") {
                    this.dataDetailsIndex = 1;
                    this.placeholder='请输入资源名称';
                    currentPathArr = [
                        {
                            title: "首页",
                            path: "databoard",
                            name: "databoard",
                            params: {
                                schoolCode: this.$route.params.schoolCode,
                            }
                        },
                        {
                            title: this.$route.params.schoolName,
                            path: "",
                            name: "schoolName"
                        },
                        {
                            title: "全部资源",
                            path: "",
                            name: "resourceList"
                        }
                    ];
                    this.$store.commit("setCurrentPath", currentPathArr);
                    this.getResourceList();
                    this.resourceViewMap();
                    this.$nextTick(() => {
                        this.dataDetailStyle.height = 705 + this.$refs.dataStatistics.clientHeight + "px";
                    })
                }
                //点击切换至微课详情
                else if (name === "microClass") {
                    this.dataDetailsIndex = 5;
                    this.placeholder='请输入微课名称';
                    this.$forceUpdate();
                    currentPathArr = [
                        {
                            title: "首页",
                            path: "databoard",
                            name: "databoard",
                            params: {
                                schoolCode: this.$route.params.schoolCode,
                            }
                        },
                        {
                            title: this.$route.params.schoolName,
                            path: "",
                            name: "schoolName"
                        },
                        {
                            title: "全部微课",
                            path: "",
                            name: "microList"
                        }
                    ];
                    this.$store.commit("setCurrentPath", currentPathArr);
                    this.getCoursewaresInfoList();
                    this.$nextTick(() => {
                        this.dataDetailStyle.height = 705 + this.$refs.dataStatistics.clientHeight + "px";
                    })
                }
                //点击切换至作业详情
                else if (name === "homework") {
                    this.dataDetailsIndex = 2;
                    this.placeholder='请输入作业名称、布置人';
                    currentPathArr = [
                        {
                            title: "首页",
                            path: "databoard",
                            name: "databoard",
                            params: {
                                schoolCode: this.$route.params.schoolCode,
                            }
                        },
                        {
                            title: this.$route.params.schoolName,
                            path: "",
                            name: "schoolName"
                        },
                        {
                            title: "全部作业",
                            path: "",
                            name: "homeworkList"
                        }
                    ];
                    this.$store.commit("setCurrentPath", currentPathArr);
                    this.getHomeworkList();
                    this.homeWorkNumMap();
                    this.$nextTick(() => {
                        this.dataDetailStyle.height = 705 + this.$refs.dataStatistics.clientHeight + "px";
                    })
                } else if (name === "classJudge") {
                    this.dataDetailsIndex = 3;
                    this.placeholder='请输入教师、学生姓名';
                    currentPathArr = [
                        {
                            title: "首页",
                            path: "databoard",
                            name: "databoard",
                            params: {
                                schoolCode: this.$route.params.schoolCode,
                            }
                        },
                        {
                            title: this.$route.params.schoolName,
                            path: "",
                            name: "schoolName"
                        },
                        {
                            title: "全部课堂互动",
                            path: "",
                            name: "classInterList"
                        }
                    ];
                    this.$store.commit("setCurrentPath", currentPathArr);
                    this.getClassInterList();
                    this.$nextTick(() => {
                        this.dataDetailStyle.height = 705 + "px";
                    })
                } else {
                    this.dataDetailsIndex = 4;
                    this.placeholder='请输入报告名称、教师姓名';
                    currentPathArr = [
                        {
                            title: "首页",
                            path: "databoard",
                            name: "databoard",
                            params: {
                                schoolCode: this.$route.params.schoolCode,
                            }
                        },
                        {
                            title: this.$route.params.schoolName,
                            path: "",
                            name: "schoolName"
                        },
                        {
                            title: "全部课堂互动",
                            path: "",
                            name: "classInterList"
                        }
                    ];
                    this.$store.commit("setCurrentPath", currentPathArr);
                    this.getReportList();
                    this.$nextTick(() => {
                        this.dataDetailStyle.height = 705 + "px";
                    })
                }
            },
            /**
             * 获取资源饼图统计
             */
            async resourceViewMap() {
                let _this = this;
                let params = {
                    schoolId: _this.filters.schoolId,
                    classId: _this.filters.classId,
                    startDate: _this.filters.startDate,
                    endDate: _this.filters.endDate,
                };
                _this.resourceMap = await resourceViewMap(params).catch(function (error) {
                    _this.$Message.error(error.message);
                });
            },
            /**
             * 获取作业饼图统计
             */
            async homeWorkNumMap() {
                let _this = this;
                let params = {
                    schoolId: _this.filters.schoolId,
                    classId: _this.filters.classId,
                    startDate: _this.filters.startDate,
                    endDate: _this.filters.endDate,
                };
                _this.homeworkMap = await homeWorkNumMap(params).catch(function (error) {
                    _this.$Message.error(error.message);
                });
            },
            /**
             * 获取资源列表
             */
            async getResourceList() {
                let _this = this;
                let params = {
                    schoolId: _this.filters.schoolId,
                    keyWord: _this.filters.keyWord,
                    startDate: _this.filters.startDate,
                    endDate: _this.filters.endDate,
                    page: _this.pageParams.page,
                    limit: _this.pageParams.limit
                };
                let resultData = await findResourceList(params).catch(function (error) {
                    _this.$Message.error(error.message);
                });
                _this.resourceList = resultData.rows;
                _this.pageParams.total = resultData.total_rows;
                _this.pageParams.pageCount = resultData.page_count;
            },
            /**
             * 获取微课列表
             */
            async getCoursewaresInfoList() {
                let _this = this;
                let params = {
                    schoolId: _this.schoolCode==0?"":_this.filters.schoolId,
                    keyWord: _this.filters.keyWord,
                    startDate: _this.filters.startDate,
                    endDate: _this.filters.endDate,
                    page: _this.pageParams.page,
                    limit: _this.pageParams.limit
                };
                let resultData = await findCoursewaresInfoList(params).catch(function (error) {
                    _this.$Message.error(error.message);
                });
                _this.microList = resultData.rows;
                _this.microClassNums = resultData.total_rows;
                _this.pageParams.total = resultData.total_rows;
                _this.pageParams.pageCount = resultData.page_count;
                _this.dataDetailsIndex=5;
                _this.$forceUpdate();
            },
            /**
             * 获取作业列表
             */
            async getHomeworkList() {
                let _this = this;
                let params = {
                    schoolId: _this.filters.schoolId,
                    keyWord: _this.filters.keyWord,
                    startDate: _this.filters.startDate,
                    endDate: _this.filters.endDate,
                    page: _this.pageParams.page,
                    limit: _this.pageParams.limit
                };
                let resultData = await findHomeWorkList(params).catch(function (error) {
                    _this.$Message.error(error.message);
                });
                _this.homeworkList = resultData.rows;
                _this.pageParams.total = resultData.total_rows;
                _this.pageParams.pageCount = resultData.page_count;
            },
            /**
             * 获取课堂评价列表
             */
            async getClassInterList() {
                let _this = this;
                let params = {
                    schoolId: _this.filters.schoolId,
                    keyWord: _this.filters.keyWord,
                    startDate: _this.filters.startDate,
                    endDate: _this.filters.endDate,
                    page: _this.pageParams.page,
                    limit: _this.pageParams.limit
                };
                let resultData = await findInterEvaLList(params).catch(function (error) {
                    _this.$Message.error(error.message);
                });
                _this.classInterList = resultData.rows;
                _this.pageParams.total = resultData.total_rows;
                _this.pageParams.pageCount = resultData.page_count;
            },
            /**
             * 获取报告列表
             */
            async getReportList() {
                let _this = this;
                let params = {
                    schoolId: _this.filters.schoolId,
                    keyWord: _this.filters.keyWord,
                    startDate: _this.filters.startDate,
                    endDate: _this.filters.endDate,
                    page: _this.pageParams.page,
                    limit: _this.pageParams.limit
                };
                let resultData = await findReportList(params).catch(function (error) {
                    _this.$Message.error(error.message);
                });
                _this.classInterList = resultData.rows;
                _this.pageParams.total = resultData.total_rows;
                _this.pageParams.pageCount = resultData.page_count;
            },
            /**
             * 翻页
             */
            handleCurrentChange(val) {
                this.pageParams.page = val;
                //资源详情
                if (this.dataDetailsIndex == 1) {
                    this.getResourceList();

                } else if (this.dataDetailsIndex == 2) {
                    //作业详情
                    this.getHomeworkList();
                } else if (this.dataDetailsIndex == 3) {
                    //课堂评价详情
                    this.getClassInterList();
                } else if (this.dataDetailsIndex == 5) {
                    //微课详情
                    this.getCoursewaresInfoList();
                } else {
                    //云端报告详情
                    this.getReportList();
                }
            },
            /**
             * 查询
             */
            handleSearch() {
                this.pageParams.total = 0;
                this.pageParams.page = 1;
                this.pageParams.pageCount = 0;
                if (this.dataDetailsIndex == 1) {
                    this.getResourceList();
                    this.resourceViewMap();
                } else if (this.dataDetailsIndex == 2) {
                    //作业详情
                    this.getHomeworkList();
                    this.homeWorkNumMap();
                } else if (this.dataDetailsIndex == 3) {
                    //课堂评价详情
                    this.getClassInterList();
                } else if (this.dataDetailsIndex == 5) {
                    //微课详情
                    this.getCoursewaresInfoList();
                } else {
                    //云端报告详情
                    this.getReportList();
                }
            },
            /**
             * 选择时间段
             */
            changeTimeSolt(type) {
                if (this.dataDetailsIndex == 2) {
                    let todayStr = this.$utils.getTodayStr();
                    //反选的情况
                    if (this.filters.timeSolt === type) {
                        this.filters.timeSolt = 0;
                        this.filters.startDate = '';
                        this.filters.endDate = '';
                    } else {
                        this.filters.timeSolt = type;
                        this.filters.endDate = todayStr + ' 23:59:59';
                    }
                    //获取近一周时间
                    if (this.filters.timeSolt === 1) {
                        // this.filters.startDate = this.$utils.getWeekStartDate() + ' 00:00:00';
                        // this.filters.endDate = this.$utils.getWeekEndDate() + ' 23:59:59';

                        this.filters.startDate = this.$utils.getSevenDayStr() + ' 00:00:00';

                    } else if (this.filters.timeSolt === 2) {
                        //获取近一月时间
                        // this.filters.startDate = this.$utils.getMonthStartDate() + ' 00:00:00';
                        // this.filters.endDate = this.$utils.getMonthEndDate() + ' 23:59:59';

                        this.filters.startDate = this.$utils.getPreMonthDay(todayStr, 1) + ' 00:00:00';

                    } else if (this.filters.timeSolt === 3) {
                        //获取近一年时间
                        // this.filters.startDate = this.$utils.getYearStartDate() + ' 00:00:00';
                        // this.filters.endDate = this.$utils.getYearEndDate() + ' 23:59:59';

                        this.filters.startDate = this.$utils.getPreMonthDay(todayStr, 12) + ' 00:00:00';
                    }
                } else {
                    //反选的情况
                    if (this.filters.timeSolt === type) {
                        this.filters.timeSolt = 0;
                        this.filters.startDate = '';
                        this.filters.endDate = '';
                    } else {
                        this.filters.timeSolt = type;
                    }
                    //获取近一周时间
                    if (this.filters.timeSolt === 1) {
                        this.filters.startDate = this.$utils.getWeekStartDate() + ' 00:00:00';
                        this.filters.endDate = this.$utils.getWeekEndDate() + ' 23:59:59';
                    } else if (this.filters.timeSolt === 2) {
                        //获取近一月时间
                        this.filters.startDate = this.$utils.getMonthStartDate() + ' 00:00:00';
                        this.filters.endDate = this.$utils.getMonthEndDate() + ' 23:59:59';
                    } else if (this.filters.timeSolt === 3) {
                        //获取近一年时间
                        this.filters.startDate = this.$utils.getYearStartDate() + ' 00:00:00';
                        this.filters.endDate = this.$utils.getYearEndDate() + ' 23:59:59';
                    }
                }
                this.handleSearch();
            },
            /**
             * 点击查看作业报告
             */
            lookWorkReport(userId, homeworkId, homeworkName, hwType, hwTypeCode) {
                let reportUrl = "";
                //答题卡
                if (hwType == 0) {
                    //web
                    reportUrl = this.homeWorkReportPath + '/report/' + userId + '/' + homeworkId + '/' + homeworkName + '/' + hwType + '/web?hwtypecode=' + hwTypeCode + '&subjectId=' + this.hwUserSubjectId;
                } else if (hwType == 1) {
                    if (hwTypeCode == '103') {
                        //菁优题库
                        reportUrl = this.homeWorkReportPath + '/jingyouReport/' + userId + '/' + homeworkId + '/' + homeworkName + '/' + hwType + '/web?hwtypecode=' + hwTypeCode + '&subjectId=' + this.hwUserSubjectId;
                    } else if (hwTypeCode == '104') {
                        //菁优题库
                        reportUrl = this.homeWorkReportPath + '/xbReport/' + userId + '/' + homeworkId + '/' + homeworkName + '/' + hwType + '/web?hwtypecode=' + hwTypeCode + '&subjectId=' + this.hwUserSubjectId;
                    } else {
                        //题库
                        reportUrl = this.homeWorkReportPath + '/questionBankReport/' + userId + '/' + homeworkId + '/' + homeworkName + '/' + hwType + '/web?hwtypecode=' + hwTypeCode + '&subjectId=' + this.hwUserSubjectId;
                    }
                }
                window.open(reportUrl, "_blank");
            },
            /**
             * 根据用户id查询学科id
             */
            async findUserSubjectByUserId(userId, homeworkId, homeworkName, hwType, hwTypeCode) {
                let _this = this;
                let userParam = {
                    userId: userId
                };

                let userData = await findUserInfo(userParam).catch(function (error) {
                    _this.$Message.error(error.message);
                });

                _this.hwUserSubjectId = userData.subjectid;
                //点击查看作业报告
                _this.lookWorkReport(userId, homeworkId, homeworkName, hwType, hwTypeCode);
            },
            /**
             * 查看云端报告
             */
            lookReport(id, type) {
                let pathName = '';
                //题型类别 choice:选择 judge:判断 blankfilling:填空 subject:主观
                switch (type) {
                    case 'choice':
                        pathName = 'objectReport';
                        break;
                    case 'judge':
                        pathName = 'objectReport';
                        break;
                    case 'subject':
                        pathName = 'subjectReport';
                        break;
                    default:
                        pathName = 'fillReport';
                        break;
                }

                let routeData = this.$router.resolve({
                    name: pathName,
                    params: {
                        workId: id
                    }
                });
                window.open(routeData.href, "_blank");
            },
            /**
             * 查看互动详情
             */
            lookInterInfo(interObj) {
                this.isShowModal = true;
                this.currentInter = interObj;
            },
            /**
             * 关闭弹窗
             */
            closeWin() {
                this.isShowModal = false;
            },
            /**
             * 预览资源
             */
            openPreview(id,resultUrl, count, type, index,fromType) {
                // type 0:其他 1.文档 2.视频 3.音频 4.图片
                if (type === 2) {
                    this.previewVideoMode = true;
                    this.videoSrc = fromType=='resource'?resultUrl + "/video.mp4":resultUrl;
                    return;
                } else if (type === 3) {
                    this.$set(this.resourceList[index], "isPlaying", 1);
                    // //获取当前预览文档的对象
                    // var sourceObj = this.resourceList.filter((sitem) => {
                    //     return id === sitem.userId;
                    // })[0];
                    // // this.currentAudioId = item.id;
                    //
                    // this.setAudioPlay(sourceObj.resultUrl);
                    return;
                }
                if (!count) {
                    this.$Message.error("暂无缩略图，无法预览！");
                    return;
                }
                this.previewMode = true;
                this.$refs.previewSlider.swiperInit(resultUrl, count);
            },
            // 关闭预览
            closePreview(type) {
                this[type] = false;
            },
            /**
             *判断不同便签页显示的内容
             */
            judgeDiffTabsContent() {
                let currentPathArr;
                if (this.tabsName == "resource") {
                    this.dataDetailsIndex = 1;
                    this.placeholder='请输入资源名称';
                    currentPathArr = [
                        {
                            title: "首页",
                            path: "databoard",
                            name: "databoard",
                            params: {
                                schoolCode: this.$route.params.schoolCode,
                            }
                        },
                        {
                            title: this.$route.params.schoolName,
                            path: "",
                            name: "schoolName"
                        },
                        {
                            title: "全部资源",
                            path: "",
                            name: "resourceList"
                        }
                    ];
                    this.$store.commit("setCurrentPath", currentPathArr);
                    this.getResourceList();
                    this.resourceViewMap();
                    this.$nextTick(() => {
                        this.dataDetailStyle.height = 705 + this.$refs.dataStatistics.clientHeight + "px";
                    })
                } else if (this.tabsName == "homework") {
                    this.dataDetailsIndex = 2;
                    this.placeholder='请输入作业名称、布置人';
                    currentPathArr = [
                        {
                            title: "首页",
                            path: "databoard",
                            name: "databoard",
                            params: {
                                schoolCode: this.$route.params.schoolCode,
                            }
                        },
                        {
                            title: this.$route.params.schoolName,
                            path: "",
                            name: "schoolName"
                        },
                        {
                            title: "全部作业",
                            path: "",
                            name: "homeworkList"
                        }
                    ];
                    this.$store.commit("setCurrentPath", currentPathArr);
                    this.getHomeworkList();
                    this.homeWorkNumMap();
                    this.$nextTick(() => {
                        this.dataDetailStyle.height = 705 + this.$refs.dataStatistics.clientHeight + "px";
                    })
                } else if (this.tabsName == "classJudge") {
                    this.dataDetailsIndex = 3;
                    this.placeholder='请输入教师、学生姓名';
                    currentPathArr = [
                        {
                            title: "首页",
                            path: "databoard",
                            name: "databoard",
                            params: {
                                schoolCode: this.$route.params.schoolCode,
                            }
                        },
                        {
                            title: this.$route.params.schoolName,
                            path: "",
                            name: "schoolName"
                        },
                        {
                            title: "全部课堂互动",
                            path: "",
                            name: "classInterList"
                        }
                    ];
                    this.$store.commit("setCurrentPath", currentPathArr);
                    this.getClassInterList();
                } else {
                    this.dataDetailsIndex = 4;
                    this.placeholder='请输入报告名称、教师姓名';
                    currentPathArr = [
                        {
                            title: "首页",
                            path: "databoard",
                            name: "databoard",
                            params: {
                                schoolCode: this.$route.params.schoolCode,
                            }
                        },
                        {
                            title: this.$route.params.schoolName,
                            path: "",
                            name: "schoolName"
                        },
                        {
                            title: "全部课堂互动",
                            path: "",
                            name: "classInterList"
                        }
                    ];
                    this.$store.commit("setCurrentPath", currentPathArr);
                    this.getReportList();
                }
            },
            // /**
            //  * 指定音频播放
            //  */
            // setAudioPlay (file_url) {
            //     $(".img-btn-box .img-delete").show();
            //
            //     $(".img-ml-box .audio").attr("src", file_url);
            //     $('#audio-player-container').show();
            //     $(".img-ml-box .canvas").hide();
            //     $('.img-ml-box').data("type", 'question').show();
            // },
            // /**
            //  * 初始化音频播放
            //  */
            // initAudio () {
            //     //获取并绑定音频播放器
            //     var $audioPlayerContainer = $('#audio-player-container'),
            //         $audioPlayer = $('#audio-player')[0],
            //         $audioPlayBtn = $('#audio-player-container .play-btn');
            //
            //     $audioPlayer.ontimeupdate = function () {
            //         var c, d, curM, curS;
            //         d = this.duration;
            //         c = this.currentTime;
            //         curM = Math.floor(c / 60);
            //         curS = Math.round(c - curM * 60);
            //         curM = curM < 10 ? ('0' + curM) : curM;
            //         curS = curS < 10 ? ('0' + curS) : curS;
            //         $audioPlayerContainer.find('.audio-progress-bar').css('width', c / d * 100 + '%');
            //         // if ($audioPlayerContainer.find('.audio-progress-bar').width() == $audioPlayerContainer.find('.audio-progress').width() - 2) {
            //         if (c / d * 100 == 100) {
            //             setTimeout(function () {
            //                 $audioPlayer.pause();
            //                 $audioPlayBtn.removeClass('play').addClass('pause');
            //                 $audioPlayerContainer.find('.audio-progress-bar').width(0);
            //             }, 1000)
            //         }
            //     };
            //     $audioPlayerContainer.on('click', '.play-btn.play', function () {
            //         $audioPlayer.pause();
            //         $audioPlayBtn.removeClass('play').addClass('pause');
            //         $audioPlayerContainer.find('.audio-progress-bar').css('width', '0px');
            //     });
            //     $audioPlayerContainer.on('click', '.play-btn.pause', function () {
            //         $audioPlayer.play();
            //         $audioPlayBtn.removeClass('pause').addClass('play');
            //     })
            // },
            // /**
            //  * 绑定音频播放点击事件
            //  */
            // bindEvent () {
            //     let _this = this;
            //     //图片预览遮————关闭
            //     $('.img-ml-box').delegate(".img-ml-bg", "click", function () {
            //         $('.img-ml-box').hide();
            //         $('.img-ml-box .audio')[0].pause();
            //         $('.img-ml-box .audio')[0].currentTime = 0;
            //         $('#audio-player-container .play-btn').removeClass('pause').addClass('play');
            //         $('#audio-player-container').hide();
            //     }).delegate(".img-ml-close", "click", function () {
            //         $('.img-ml-box').hide();
            //         $('.img-ml-box .audio')[0].pause();
            //         $('.img-ml-box .audio')[0].currentTime = 0;
            //         $('#audio-player-container .play-btn').removeClass('pause').addClass('play');
            //         $('#audio-player-container').hide();
            //     });
            // }
        },
        mounted() {
            //判断不同便签页显示的内容
            this.judgeDiffTabsContent();
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../../style/detailPage";

    .circle-data {
        background: url("../../../../assets/images/databoard/detailPage/green-circle.png") top no-repeat;
    }

    .panel-box {
        background-image: url("../../../../assets/images/databoard/modal-bg.png");
        background-repeat: no-repeat;
        background-size: 100% 100%
    }
    /*图片预览遮罩层*/
    .img-ml-box {
        position: fixed;
        top: 0px;
        height: 100%;
        left: 0px;
        right: 0px;
        bottom: 0px;
        width: 100%;
        z-index: 50;
        display: none;
    }

    /*遮罩层背景*/
    .img-ml-box .img-ml-bg {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0px;
        top: 0px;
        right: 0px;
        bottom: 0px;
        background: #000;
        opacity: 0.8;
        z-index: 55;
    }

    /*关闭按钮*/
    .img-ml-box .img-ml-close {
        position: absolute;
        right: 15px;
        top: 10px;
        width: 32px;
        height: 32px;
        z-index: 999;
        opacity: 0.6;
        background: url('../../../../assets/images/databoard/close.png') center center no-repeat;
    }

    .img-ml-box .img-ml-close:hover {
        opacity: 1;
    }

    .audio-player-container {
        position: absolute;
        z-index: 70;
        top: 44%;
        left: 50%;
        width: 70%;
        max-width: 1200px;
        padding: 33px 80px 33px 156px;
        margin: 0 auto;
        display: block;
        background-color: #fff;
        border-radius: 5px;
        -webkit-transform: translate3d(-50%, -50%, 0);
        -moz-transform: translate3d(-50%, -50%, 0);
        -ms-transform: translate3d(-50%, -50%, 0);
        -o-transform: translate3d(-50%, -50%, 0);
        transform: translate3d(-50%, -50%, 0);
        display: none;
    }

    .audio-player-container .audio-progress {
        width: 100%;
        height: 24px;
        background: rgba(239, 241, 250, 1);
        border: 1px solid rgba(232, 234, 244, 1);
        border-radius: 12px;
        overflow: hidden;
    }

    .audio-player-container .audio-progress .audio-progress-bar {
        height: 100%;
        background: rgba(62, 115, 246, 1);
        border-radius: 12px;
    }

    .audio-player-container .play-btn {
        position: absolute;
        top: 21px;
        left: 71px;
        width: 50px;
        height: 50px;
        background: url("../../../../assets/images/databoard/icon-audioplayer.png") no-repeat;
        cursor: pointer;
    }

    .audio-player-container .play-btn:active {
        opacity: .6;
    }

    .audio-player-container .play-btn.play {
        background-position: 1px 1px;
    }

    .audio-player-container .play-btn.pause {
        background-position: 1px -64px;
    }
</style>

<style lang="scss">
    .data-tab-area {
        .ivu-tabs-bar {
            border-bottom: 0;
            background: #f2f5f3;
        }

        .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-nav-container {
            height: 40px;
        }

        .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab {
            height: 40px;
            margin-right: 1px;
            padding: 9px 16px 4px;
        }

        .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab-active {
            height: 40px;
            color: #00caaf;
        }

        .ivu-tabs-nav .ivu-tabs-tab:hover {
            color: #00caaf;
        }

        .ivu-tabs-nav-container:focus .ivu-tabs-tab-focused {
            border-color: #dcdee2 !important;
        }
    }
    .right-mian {
        right: 100px;
    }
    .right-mian_active {
        float: right;
    }
</style>

